// import { Button } from '@mui/material';
// import React, { useEffect } from 'react';
// import { usePagination } from './usePagination';
// import "../../css/Pagination.css"
// export default function Pagination(props) {
//     const {
//         onPageChange,
//         totalCount,
//         siblingCount = 4,
//         currentPage,
//         pageSize,
//     } = props;

//     const paginationRange = usePagination({
//         currentPage,
//         totalCount,
//         siblingCount,
//         pageSize,
//     });

//     const firstPage = () => {
//         onPageChange(1);
//     }
//     const lastPages = () => {
//         onPageChange(lastPage);
//     }
//     const onNext = () => {
//         onPageChange(currentPage + 1);
//     };

//     const onPrevious = () => {
//         onPageChange(currentPage - 1);
//     };
//     const prevTen = () => {
//         onPageChange(currentPage - 10);
//     }
//     const nextTen = () => {
//         onPageChange(currentPage + 10);
//     }

//     const lastPage = (totalCount > 0 && pageSize > 0) ? Math.ceil(totalCount / pageSize) : 1;

//     return (
//         <div className="paginationWrapper">
//             <div className="paginationCopy">
//                 <Button className="buttons" onClick={firstPage} disabled={currentPage === 1}>First</Button>
//                 <Button className="buttons" disabled={currentPage <= 10} onClick={prevTen}>Prev 10</Button>
//                 <Button className="buttons" disabled={currentPage === 1} onClick={onPrevious}>Prev</Button>
//                 {paginationRange?.map((pageNumber, key, i) => {
//                     return (
//                         <Button onClick={() => onPageChange(pageNumber)}
//                             className={pageNumber === currentPage ? "active" : "inActive"} key={i + key + pageNumber}>{pageNumber}</Button>
//                     );
//                 })}
//                 <Button className="buttons" disabled={totalCount === 0 || currentPage === lastPage} onClick={onNext}>Next</Button>
//                 <Button className="buttons" disabled={lastPage - currentPage < 10} onClick={nextTen}>Next 10</Button>
//                 <Button className="buttons" disabled={totalCount === 0 || currentPage === lastPage} onClick={lastPages}>Last</Button>
//                 <span className="count">Page {lastPage === 0 ? 0 : currentPage} of {lastPage || 1}</span>
//             </div>
//         </div>
//     )
// }

import React from "react";

export default function Pagination({
  currentPage,
  totalCount,
  pageSize,
  onPageChange,
  onPageSizeChange,
}) {
  const lastPage = Math.ceil(totalCount / pageSize) || 1;

  const startIndex = (currentPage - 1) * pageSize + 1;
  const endIndex = Math.min(currentPage * pageSize, totalCount);

  // Generate pages (show chunks of 10 like 1–10, 11–20 etc.)
  const generatePages = () => {
    const chunkStart = Math.floor((currentPage - 1) / 10) * 10 + 1;
    const chunkEnd = Math.min(chunkStart + 9, lastPage);

    const pages = [];
    for (let i = chunkStart; i <= chunkEnd; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className="flex justify-center items-center w-full gap-6 my-6 py-2">
      {/* Showing entries */}
      <p className="text-sm text-gray-600">
        Showing {startIndex} to {endIndex} of {totalCount} entries
      </p>

      {/* Pagination buttons + dropdown */}
      <div className="flex items-center gap-2">
        {/* First page */}
        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          className="px-2 py-1 border rounded disabled:opacity-50"
        >
          «
        </button>

        {/* Previous */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-2 py-1 border rounded disabled:opacity-50"
        >
          ‹
        </button>

        {/* Page numbers */}
        {generatePages().map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`px-3 py-1 border rounded ${
              page === currentPage
                ? "bg-[#FF702B] text-white"
                : "bg-white hover:bg-gray-100"
            }`}
          >
            {page}
          </button>
        ))}

        {/* Next */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === lastPage}
          className="px-2 py-1 border rounded disabled:opacity-50"
        >
          ›
        </button>

        {/* Last page */}
        <button
          onClick={() => onPageChange(lastPage)}
          disabled={currentPage === lastPage}
          className="px-2 py-1 border rounded disabled:opacity-50"
        >
          »
        </button>

        {/* Page size dropdown */}
        <select
          value={pageSize}
          onChange={(e) => {
            const newSize = Number(e.target.value);
            onPageSizeChange(newSize);
          }}
          className="ml-2 border border-gray-300 rounded px-2 py-1 text-sm"
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
        </select>
      </div>
    </div>
  );
}
